import { render, staticRenderFns } from "./CollapserMenu.vue?vue&type=template&id=42ec7fcd&scoped=true&"
import script from "./CollapserMenu.vue?vue&type=script&lang=js&"
export * from "./CollapserMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollapserMenu.vue?vue&type=style&index=0&id=42ec7fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec7fcd",
  null
  
)

export default component.exports